import { useEffect } from "react";

export default function AdComponent({
    adSlot,
    adClient = "ca-pub-4543299401995008",
    adFormat = "auto",
    style = { display: "block" },
    fullWidthResponsive = true,
    layoutKey,
    className = "adsbygoogle",
}) {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error("AdSense error", e);
        }
    }, []);

    return (
        <ins
            className={className}
            style={style}
            data-ad-client={adClient}
            data-ad-slot={adSlot}
            data-ad-format={adFormat}
            data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
            {...(layoutKey && { "data-ad-layout-key": layoutKey })}
        />
    );
}
